export default __webpack_public_path__ + "static/media/1746.5d4fb970.png";